import getServiceCodeSearch from "./getServiceCodeSearch";
import getServiceCodePagination from "./getServiceCodePagination";

export const serviceCodes = {
  getServiceCodeSearch,
  getServiceCodePagination
};
